export const SET_TRUSTPILOT = 'SET_TRUSTPILOT';

export function setTrustpilot() {
    return {
        type: SET_TRUSTPILOT,
    };
}

export default function reduceTrustpilot(state = {}, action) {
    switch (action.type) {
        case SET_TRUSTPILOT:
            return {
                ...state,
                ...action.payload,
            };

        default:
            return state;
    }
}
